import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input} from 'antd'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('mappingManagementStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()

  componentDidMount() {
    const {record} = this.props
    this.formRef.current.setFieldsValue({
      format: JSON.stringify(JSON.parse(record.data), null, 4)
    })
  }

  render() {
    const {addModalVisible, handleCancel, title, t} = this.props
    return (
      <>
        <Modal
          title={title === 'MAPPING' ? t(`mappingManagement.mappingStructure`) : t(`mappingManagement.apiStructure`)}
          // closable={false}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          width="60%"
          centered
          onCancel={handleCancel}
          footer={null}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[10, 0]}>
              <Col span={24}>
                <Form.Item name="format" label={t(`mappingManagement.format`)} htmlFor={null}>
                  <TextArea rows={20}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
